import React, { useContext, useEffect, useState } from "react";
import { AccountContext } from '../../../Contexts/main.context';

const UsersComponent = () => {
    const context = useContext(AccountContext);
    const { userAccounts, updateUserAccounts } = context || {};

    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [editUser, setEditUser] = useState(null);
    const [newUser, setNewUser] = useState({
        displayName: '',
        email: '',
        password: '',
        iconSex: 'Male',
        phone: '',
        accountSecurity: ''
    });
    const [editData, setEditData] = useState({});

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await fetch("https://www.lgfantasy.ca/Citations/PHP/data.php", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ script: "getUsers" }),
                });

                const data = await response.json();
                updateUserAccounts(data.results || data); // support old/new format
            } catch (err) {
                console.error("Fetch error:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchUsers();
    }, []);

    const handleCreateUser = async () => {
        const payload = {
            script: "createUser",
            ...newUser,
        };

        try {
            const response = await fetch("https://www.lgfantasy.ca/Citations/PHP/data.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            const result = await response.json();
            if (result.status === "success") {
                updateUserAccounts(result.results);
                setShowModal(false);
                setNewUser({ displayName: '', email: '', password: '', iconSex: 'Male', phone: '', accountSecurity: '' });
            } else {
                alert("Failed to create user.");
            }
        } catch (error) {
            console.error("Create error:", error);
            alert("Error creating user.");
        }
    };

    const handleOpenEdit = (user) => {
        setEditUser(user);
        setEditData({
            ID: user.ID,
            displayName: user.displayName,
            phone: user.phone,
            password: '',
            accountSecurity: user.accountSecurity
        });
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditData(prev => ({ ...prev, [name]: value }));
    };

    const handleSaveEdit = async () => {
        const payload = {
            script: "updateUser",
            ...editData
        };

        try {
            const response = await fetch("https://www.lgfantasy.ca/Citations/PHP/data.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            const result = await response.json();
            if (result.status === "success") {
                const updatedList = userAccounts.map(user =>
                    user.ID === editData.ID ? { ...user, ...editData, password: undefined } : user
                );
                updateUserAccounts(updatedList);
                setEditUser(null);
            } else {
                alert("Failed to update user.");
            }
        } catch (err) {
            console.error("Error updating user:", err);
            alert("An error occurred while updating.");
        }
    };

    const handleDeleteUser = async () => {
        if (!window.confirm("Are you sure you want to delete this user?")) return;

        try {
            const response = await fetch("https://www.lgfantasy.ca/Citations/PHP/data.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                 body: JSON.stringify({ script: "deleteUser", ID: editUser.ID }),
            });

            const result = await response.json();
            if (result.status === "success") {
                updateUserAccounts(result.results);
                setEditUser(null);
            } else {
                alert("Failed to create user.");
            }
        } catch (error) {
            console.error("Create error:", error);
            alert("Error creating user.");
        }
    };


    if (loading) return <div className="text-center p-3">Loading Users...</div>;

    return (
        <div className="container-fluid rounded-2">
            <div className="p-2 text-center fs-4 text-navy fw-bold mb-2">All Users</div>

            <div className="d-flex flex-wrap gap-1 justify-content-center">
                {userAccounts.map((user, index) => (
                    <div
                        key={index}
                        className="location-card p-2 col-11 mb-3 bg-primary"
                        onClick={() => handleOpenEdit(user)}
                    >
                        <div className="d-flex flex-column align-items-center mt-2">
                            <img
                                src={user.myPicture}
                                alt={user.displayName}
                                className="rounded-circle mb-2"
                                style={{ width: 80, height: 80, objectFit: 'cover', background: '#fff' }}
                            />
                            <div className="text-white fw-bold mt-2">{user.displayName}</div>
                            <div className="text-lemon small">{user.email}</div>
                            <div className="text-white small">{user.phone}</div>
                            <button
                                className={`btn btn-sm ${user.accountSecurity === "Admin" ? "btn-info" : "btn-secondary text-white"} mt-2`}
                            >
                                {user.accountSecurity || "No Role"}
                            </button>
                        </div>
                    </div>
                ))}

                <div
                    className="location-card col-11 mb-3 alert-success create-location-box d-flex justify-content-center align-items-center"
                    onClick={() => setShowModal(true)}
                    style={{ border: "3px dotted green", cursor: "pointer", minHeight: 160 }}
                >
                    <div className="text-center">
                        <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                            <path d="M12 5v14M5 12h14" stroke="green" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                        <div className="fw-bold h5 mt-2">Add New User</div>
                    </div>
                </div>
            </div>

            {/* Create Modal */}
            {showModal && (
                <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
                    <div className="modal-dialog modal-dialog-centered modal-md">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Create New User</h5>
                                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-2">
                                    <label>Display Name</label>
                                    <input type="text" className="form-control" value={newUser.displayName} onChange={(e) => setNewUser(prev => ({ ...prev, displayName: e.target.value }))} />
                                </div>
                                <div className="mb-2">
                                    <label>Email</label>
                                    <input type="email" className="form-control" value={newUser.email} onChange={(e) => setNewUser(prev => ({ ...prev, email: e.target.value }))} />
                                </div>
                                <div className="mb-2">
                                    <label>Password</label>
                                    <input type="text" className="form-control" value={newUser.password} onChange={(e) => setNewUser(prev => ({ ...prev, password: e.target.value }))} />
                                </div>
                                <div className="mb-2">
                                    <label>Phone</label>
                                    <input type="text" className="form-control" value={newUser.phone} onChange={(e) => setNewUser(prev => ({ ...prev, phone: e.target.value }))} />
                                </div>
                                <div className="mb-2">
                                    <label>Gender</label>
                                    <select className="form-select" value={newUser.iconSex} onChange={(e) => setNewUser(prev => ({ ...prev, iconSex: e.target.value }))}>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                        <option value="">Other</option>
                                    </select>
                                </div>
                                <div className="mb-2">
                                    <label>Account Security</label>
                                    <select className="form-select" value={newUser.accountSecurity || ""} onChange={(e) => setNewUser(prev => ({ ...prev, accountSecurity: e.target.value }))}>
                                        <option value="">Select...</option>
                                        <option value="Admin">Admin</option>
                                        <option value="Manager">Manager</option>
                                    </select>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
                                <button className="btn btn-primary" onClick={handleCreateUser}>Create User</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Modal */}
            {editUser && (
                <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
                    <div className="modal-dialog modal-dialog-centered modal-md">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Edit User: {editUser.displayName}</h5>
                                <button type="button" className="btn-close" onClick={() => setEditUser(null)}></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-2">
                                    <label>Display Name</label>
                                    <input className="form-control" name="displayName" value={editData.displayName} onChange={handleEditChange} />
                                </div>
                                <div className="mb-2">
                                    <label>Phone</label>
                                    <input className="form-control" name="phone" value={editData.phone} onChange={handleEditChange} />
                                </div>
                                <div className="mb-2">
                                    <label>Account Role</label>
                                    <select className="form-select" name="accountSecurity" value={editData.accountSecurity} onChange={handleEditChange}>
                                        <option value="Admin">Admin</option>
                                        <option value="Manager">Manager</option>
                                    </select>
                                </div>
                                <div className="mb-2">
                                    <label>New Password (optional)</label>
                                    <input type="password" className="form-control" name="password" value={editData.password} onChange={handleEditChange} />
                                </div>
                            </div>
                            <div className="modal-footer justify-content-between">
                                <button className="btn btn-danger" onClick={handleDeleteUser}>Delete</button>
                                <div>
                                    <button className="btn btn-secondary me-2" onClick={() => setEditUser(null)}>Cancel</button>
                                    <button className="btn btn-primary" onClick={handleSaveEdit}>Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UsersComponent;